import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import { Spinner } from "reactstrap";

//Import Context
import { useAuth } from "../../contexts/AuthContext";
import { useProfile } from "../../contexts/ProfileContext";

//Import Images
import config from "../../config";

import "react-toastify/dist/ReactToastify.css";
// import house_icon from "../../assets/images/register_bg.png";
import house_icon from "../../assets/images/auth_home_icon.webp";

import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { FaApple, FaFacebook, FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { FcGoogle } from "react-icons/fc";
import { showErrorToast, showSuccessToast } from "../utils";
import AppleLogin from "react-apple-login";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import PhoneInputField from "../../components/PhoneInput/PhoneInput";

/**
 * Register component
 * @param {*} props
 */

const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID || "974991728146351";

const Register = () => {
    const navigate = useNavigate();
    const { registerUserSuccess, loading: authLoading, error: authError, clearError } = useAuth();
    const { fetchProfile } = useProfile();

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("1");
    const [showPassword, setShowPassword] = useState(false);
    const [fullName, setFullName] = useState("");
    const [isOAuthRegistration, setIsOAuthRegistration] = useState(false);
    const [validationError, setValidationError] = useState({});
    let payload = {
        first_name: "",
        role: "",
        last_name: "",
        email: "",
        phone: "",
        facebook: "",
        google: "",
        gmail: "",
        linkedin: "",
        password: "",
    };
    // Using auth context state directly

    // Success handling is now done in the registerApi function

    useEffect(() => {
        clearError();
    }, [clearError]);

    document.title = `Register | ${config.get("COMPANY_NAME")}`;

    const registerApi = async (info, isManualRegister) => {
        setLoading(true);
        // setErrorMsg(null);

        const requestUrl = `${config.get("API_URL")}/user/register`;

        try {
            const response = await fetch(requestUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ ...info }),
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                console.log("errorResponse", response.status);
                if (response.status === 409) {
                    toast.success("Account already exists, we have sent you a verification email, please verify.");
                    return navigate("/Verify-otp", { state: { email: email, from: "verifyemail" } });
                }
                showErrorToast(`Registration Failed: ${errorResponse?.detail}`, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
                return;
                // throw new Error("Network response was not ok: " + errorResponse.error);
            }

            const data = await response.json();
            if (data?.access_token) {
                // Store tokens in localStorage
                localStorage.setItem("authUser", JSON.stringify(data.access_token));
                localStorage.setItem("refreshToken", JSON.stringify(data.refresh_token));

                // Update AuthContext with registration success
                registerUserSuccess({
                    user: data.user || {},
                    token: data.access_token,
                });

                // Fetch fresh profile data
                await fetchProfile();

                navigate("/properties", { replace: true });
                return;
            } else if (data.message === "User registered successfully" && !data.requires_verification) {
                showSuccessToast("Registration successful");
                return navigate("/signin");
            }

            if (data.requires_verification) {
                navigate("/Verify-otp", { state: { email: email, from: "verifyemail" } });
            }

            if (data.message) {
                sessionStorage.setItem("userInfo", JSON.stringify(data));
                navigate("/Verify-otp", { state: { email: email, from: "verifyemail" } });
            } else {
                if (data.error) {
                    throw new Error(data.error);
                }
                setErrorMsg("Registration failed: No success message received");
                throw new Error("Registration failed: No success message received");
            }
        } catch (error) {
            showErrorToast(error.error || "Registration failed due to an unexpected error.");
            console.error("Registration error:", error);
            setErrorMsg(error.error || "Registration failed due to an unexpected error.");
            setErrorMsg(error.message || "Registration failed due to an unexpected error.");
        } finally {
            setLoading(false);
        }
    };
    const handleRegister = async (e) => {
        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setErrorMsg("Please enter a valid email address.");
            return;
        }

        const values = {
            first_name: fullName.split(" ")[0],
            last_name: fullName.split(" ")[1] || "",
            gmail: email,
            email: email,
            phone: phone.startsWith("+") ? phone : "+" + phone,
            linkedIn: "",
            google: "",
            password: password,
            role: "",
        };

        const passwordRegx = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/;
        if (!passwordRegx.test(password)) {
            setValidationError((pre) => ({ ...pre, password: true }));
            setLoading(false);
            return;
        } else {
            setValidationError((pre) => ({ ...pre, password: false }));
        }

        registerApi(values, true);
    };
    const onGoogleButtonPress = useGoogleLogin({
        onSuccess: async (response) => {
            // Get the access token from the response
            const accessToken = response.access_token;

            try {
                // Fetch user information using the access token
                const userInfoResponse = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                let payload = {
                    email: userInfoResponse.email,
                    google: userInfoResponse.sub,
                    first_name: userInfoResponse?.name.split(" ")[0],
                    last_name: userInfoResponse?.name.split(" ")[1] || "",
                    facebook: userInfoResponse?.id,
                };

                registerApi(payload);
            } catch (error) {
                console.error("Failed to fetch user info", error);
                showErrorToast("Failed to fetch user info");
            }
        },
        onError: (error) => {
            console.error("Google login failed", error);
            showErrorToast("Google login failed, please try again.");
            setErrorMsg("Google login failed, please try again.");
        },
    });

    const responseFacebook = (response) => {
        setIsOAuthRegistration(true);
        if (!window.FB) {
            showErrorToast("Facebook login failed, please try again.");
            setErrorMsg("Facebook login failed, please try again.");
            return;
        }
        if (response.accessToken) {
            fetch(`https://graph.facebook.com/me?access_token=${response.accessToken}&fields=name,email,picture`)
                .then((res) => res.json())
                .then((userData) => {
                    const payload = {
                        email: userData.email,
                        first_name: userData?.name.split(" ")[0],
                        last_name: userData?.name.split(" ")[1],
                        facebook: userData?.id,
                    };
                    registerApi(payload);
                })
                .catch((error) => {
                    console.error("Error fetching user data:", error);
                });
        } else {
            showErrorToast("Facebook login failed, please try again.");
            setErrorMsg("Facebook login failed, please try again.");
        }
    };

    return (
        <div className="auth-main-wrapper">
            <div
                className="md:tw-bg-none tw-bg-center tw-bg-cover tw-w-full tw-h-full tw-flex tw-justify-between max-sm:tw-overflow-y-scroll"
                style={{ backgroundImage: `url(${house_icon})` }}
            >
                <div
                    style={{ backgroundImage: `url(${house_icon})` }}
                    className="max-sm:tw-hidden tw-relative tw-bg-center tw-bg-cover tw-w-full tw-m-2 "
                >
                    <div className="tw-absolute tw-inset-0 tw-bg-black tw-opacity-30"></div>

                    <div className="tw-absolute tw-top-[40px] tw-left-[30px] tw-flex tw-gap-2 tw-z-10">
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/5c704c298b9ced9c12fdf92061da095dec0b48ab751d0dab56ea704d9d9b3733?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                            alt="AiRE BROKERS logo"
                            className="logo tw-w-[35px] tw-h-[35px]"
                        />
                        <span className={`brandName tw-text-[16px] `}>{config.get("COMPANY_NAME")}</span>
                    </div>
                </div>

                <div
                    className="tw-h-full  max-sm:tw-h-fit tw-w-full max-sm:tw-text-white max-sm:tw-bg-blur_background max-sm:tw-backdrop-blur-lg max-sm:tw-rounded-tl-[40px] max-sm:tw-rounded-tr-[40px]  md:tw-px-10 max-sm:tw-px-5  max-sm:tw-mt-52 tw-flex tw-overflow-y-auto tw-justify-center tw-z-10 "
                    // style={{ background: "rgba(0, 0, 0, 0.68)" }}
                >
                    <div className="md:tw-max-w-[526px] 2xl:tw-max-w-[721px] tw-h-full tw-items-center  tw-flex tw-justify-center tw-pt-5  tw-w-full max-sm:tw-mt-10 max-sm:tw-mb-3">
                        <div className="tw-flex tw-flex-col tw-gap-2  2xl:tw-gap-5">
                            <div className=" mb-1">
                                {/* Title */}
                                <div className="mb-1 tw-flex tw-flex-col tw-gap-[10px]">
                                    <h1 className="tw-text-[36px] tw-font-semibold tw-text-center 2xl:tw-text-[50px] max-sm:tw-text-[24px] ">
                                        Sign Up for {config.get("COMPANY_NAME")}
                                    </h1>
                                    <p className="tw-text-[16px] tw-text-center 2xl:tw-text-[20px] md:tw-text-semi_dark_text max-sm:tw-font-thin">
                                        Create an account to access your real estate dashboard.
                                    </p>
                                </div>
                            </div>

                            <form onSubmit={(e) => handleRegister(e)} className="tw-flex tw-flex-col tw-gap-2 2xl:tw-gap-5">
                                <div className=" tw-flex tw-flex-col tw-gap-2  2xl:tw-gap-5">
                                    <div className="tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                        <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Full Name</span>

                                        <input
                                            type="text"
                                            value={fullName}
                                            required={isOAuthRegistration ? false : true}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only alphabetic characters and spaces
                                                if (/^[a-zA-Z\s]*$/.test(value)) {
                                                    setFullName(value);
                                                }
                                            }}
                                            placeholder="Enter your name"
                                            className="tw-px-3 tw-py-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] tw-h-[50px] tw-border tw-border-border_color 2xl:tw-text-[22px] max-sm:tw-text-white"
                                        />
                                    </div>

                                    <div className="tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                        <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Email Address</span>
                                        <input
                                            type="email"
                                            required={isOAuthRegistration ? false : true}
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Enter your email address"
                                            className="tw-px-3 tw-py-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] tw-h-[50px] tw-border tw-border-border_color 2xl:tw-text-[22px] max-sm:tw-text-white"
                                        />
                                    </div>
                                    <div className="tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                        <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Phone Number</span>
                                        <PhoneInputField 
                                            phone={phone} 
                                            setPhone={setPhone} 
                                            inputClass="tw-bg-background_color max-sm:tw-bg-transparent 2xl:tw-text-[22px] max-sm:tw-text-white max-sm:tw-placeholder-white"
                                        />
                                    </div>

                                    <div className=" tw-w-full tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                        <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Password </span>
                                        <div className="tw-relative ">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                required={isOAuthRegistration ? false : true}
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                placeholder="Enter your password"
                                                className="tw-px-3 tw-pr-12 tw-py-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] tw-h-[50px] tw-border tw-border-border_color 2xl:tw-text-[22px] max-sm:tw-text-white"
                                            />
                                            {validationError.password && (
                                                <p className="tw-text-red-600 tw-text-[12px]">
                                                    *Minimum 8 characters, including at least one letter and one number
                                                </p>
                                            )}

                                            {/* Toggle Button */}
                                            <button
                                                type="button"
                                                onClick={() => setShowPassword((prev) => !prev)}
                                                className="tw-absolute tw-right-3 tw-top-1/2 tw-transform tw--translate-y-1/2"
                                            >
                                                {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                                            </button>
                                        </div>
                                    </div>
                                    {errorMsg && <div className="tw-text-red-500 tw-text-sm tw-mt-2">{errorMsg}</div>}
                                </div>

                                <>
                                    <div className="tw-flex tw-justify-center tw-w-full tw-items-center tw-gap-2  tw-text-[13px]">
                                        <div className="max-sm:tw-hidden tw-h-[1px] tw-border-[#D0D5DD] tw-w-[100px] tw-border-b-1 tw-bg-white"></div>
                                        <p className="2xl:tw-text-[22px] tw-text-[16px]  md:tw-font-semibold">Or continue with</p>
                                        <div className="max-sm:tw-hidden tw-h-[1px] tw-border-[#D0D5DD] tw-w-[100px] tw-border-b-1 tw-bg-white"></div>
                                    </div>

                                    <div className="tw-w-full tw-flex tw-justify-center">
                                        <div className="tw-flex max-sm:tw-w-fit tw-text-[8px] md:tw-text-[14px] tw-gap-5  tw-text-black tw-items-center tw-text-center tw-justify-center ">
                                            <button
                                                onClick={() => {
                                                    setIsOAuthRegistration(true);
                                                    onGoogleButtonPress();
                                                }}
                                                className="tw-bg-icon_background  tw-w-fit tw-justify-center tw-p-2  max-sm:tw-w-full tw-rounded-full tw-flex md:tw-gap-2 tw-items-center"
                                            >
                                                <FcGoogle className="tw-text-[20px] max-sm:tw-text-[15px] tw-object-contain" />
                                            </button>

                                            <FacebookLogin
                                                appId={FACEBOOK_APP_ID}
                                                autoLoad={false}
                                                scope="public_profile,email"
                                                callback={responseFacebook}
                                                render={(renderProps) => (
                                                    <button
                                                        onClick={renderProps.onClick}
                                                        className="tw-bg-icon_background  tw-w-fit tw-justify-center tw-p-2 max-sm:tw-w-full tw-rounded-full tw-flex md:tw-gap-2 tw-items-center"
                                                    >
                                                        <FaFacebook className="tw-text-[20px] max-sm:tw-text-[15px] tw-text-blue-500 tw-object-contain" />
                                                    </button>
                                                )}
                                            />
                                            <AppleLogin
                                                clientId="com.airebrokers.admin"
                                                redirectURI="https://admin.airebrokers.com/register"
                                                usePopup={true}
                                                callback={async (response) => {
                                                    if (!response?.authorization?.id_token) {
                                                        showErrorToast("Apple login failed, please try again.");
                                                        return;
                                                    }
                                                    const data = await jwtDecode(response.authorization?.id_token);
                                                    let payload = {
                                                        applekey: data.sub,
                                                        email: data.email,
                                                        first_name: response.user?.name?.firstName || "",
                                                        last_name: response.user?.name?.lastName || "",
                                                        phone: "",
                                                        google: "",
                                                        facebook: "",
                                                    };
                                                    // remove the null or empty values from the payload object
                                                    payload = Object.fromEntries(Object.entries(payload).filter(([_, v]) => v));
                                                    registerApi(payload);
                                                }} // Catch the response
                                                scope="email name"
                                                responseMode="query"
                                                render={(
                                                    renderProps //Custom Apple Sign in Button
                                                ) => (
                                                    <button
                                                        // onClick={loginWithApple}
                                                        onClick={renderProps.onClick}
                                                        className="tw-bg-icon_background  tw-w-fit tw-justify-center tw-p-2 max-sm:tw-w-full tw-rounded-full tw-flex md:tw-gap-2 tw-items-center"
                                                    >
                                                        <FaApple className="tw-text-[20px] max-sm:tw-text-[15px] tw-object-contain" />
                                                    </button>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </>

                                <div className="tw-flex tw-flex-col">
                                    <button
                                        type="submit"
                                        disabled={!email || !password || !phone || !fullName}
                                        className={`tw tw-border-none tw-bg-primary tw-text-white tw-mt-5 tw-p-3 tw-rounded-md 2xl:tw-text-[18px] `}
                                    >
                                        {loading ? <Spinner size="sm" color="light" /> : "Create Account"}
                                    </button>
                                    <div className="tw-flex tw-mt-4 tw-justify-center tw-gap-2 tw-items-center tw-w-full 2xl:tw-text-[18px]">
                                        <p>Already have an account? </p>
                                        <Link to="/login" className="text-muted tw-text-center tw-text-primary hover:tw-text-primary_hover">
                                            Login
                                        </Link>
                                    </div>
                                    <div className="tw-flex tw-flex-col md:tw-flex-row tw-text-[14px] xl:tw-text-base tw-mt-2 tw-justify-center tw-gap-2 tw-items-center tw-w-full 2xl:tw-text-[18px]">
                                        <p>Already have an account but forgot password? </p>
                                        <Link to="/forget-password" className="text-muted tw-text-center tw-text-primary hover:tw-text-primary_hover">
                                            Forgot Password
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
